/* eslint-disable import/no-internal-modules */
import PaginationComponent, { PaginationProps } from '@insided/deprecated-control/ui-components/PaginationComponent'
import DropdownControl from '@insided/deprecated-preact-components/dropdown/DropdownControl'
import Button from '@insided/control/uikit/Button'
import { Reply } from '../../interfaces'
import { REPLY_SORTING_OPTIONS } from './utils'

interface Props {
  replyCount: number
  replies: Reply[]
  repliesPagination: PaginationProps
  getReplies: (page?: number, pageSize?: number, sort?: string) => Promise<any>
  repliesSorting: string
  setRepliesSorting: (repliesSorting: string) => void
}

const RepliesHeader = ({ replyCount, replies, repliesPagination, getReplies, repliesSorting, setRepliesSorting }: Props) => {
  return (
    <div className='topic-moderation--replies-header'>
      <h4>
        <strong>{replyCount} Replies</strong>
      </h4>
      {replies.length > 0 &&
        <PaginationComponent
          pagination={repliesPagination}
          onPageChange={(async page => await getReplies(page, repliesPagination.pageSize))}
          onPageSizeChange={async pageSize => await getReplies(1, pageSize)}
        />}
      {replies.length > 0 &&
        <DropdownControl
          align='adjust'
          triggerClass='dropdown-wrapper'
          trigger={
            <Button
              icon='arrowDropdown' title={REPLY_SORTING_OPTIONS[repliesSorting]}
                  // eslint-disable-next-line @gorazdo/preact/prefer-classname
              className='qa-topic-moderation-reply-sort'
            />
          }
          items={
            Object.keys(REPLY_SORTING_OPTIONS).map((value: string) => ({
                title: REPLY_SORTING_OPTIONS[value],
                value,
                onClick: async () => await getReplies(1, repliesPagination.pageSize, value)
                  .then(() => setRepliesSorting(value))
            }))
          }
        />}
    </div>
  )
}

export default RepliesHeader
